import React from "react";
import { Box } from "@mui/material";
import { WireGuardTunnel } from "./wireGuardTunnelsInterfaces";

interface Props {
  tunnelName: string;
  matchedTunnel: WireGuardTunnel | null;
  onOpenTunnel: (tunnel: WireGuardTunnel) => void;
}

export const WireguardTunnelNameLink = ({
  tunnelName,
  matchedTunnel,
  onOpenTunnel,
}: Props) => {
  if (!tunnelName) {
    return <>-</>;
  }

  if (!matchedTunnel) {
    return <>{tunnelName}</>;
  }

  return (
    <Box
      component="button"
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        onOpenTunnel(matchedTunnel);
      }}
      sx={{
        fontFamily: "Mulish",
        fontSize: "inherit",
        color: "#283E6D",
        textDecoration: "underline",
        cursor: "pointer",
        p: 0,
        border: 0,
        background: "none",
        textAlign: "left",
        overflowWrap: "anywhere",
        wordBreak: "break-word",
      }}
    >
      {tunnelName}
    </Box>
  );
};
